import { assert } from './misc'

/**
 * Memorize a function result, can be used to optimise functions that are 
 * called multiple times with the same value
 */
export function memorize<T extends (...args: any[]) => any>(
  handler: T,
  options: any
): T {

  const { 
    cacheKey: cacheKeyFunction, 
  } = options

  assert(cacheKeyFunction, 'cacheKey is required.')
  var cache = {}
  return function(...args: Parameters<T>): ReturnType<T> {
    var cacheKey = cacheKeyFunction(args)
    if (cache[cacheKey]){
      return cache[cacheKey]
    }
    cache[cacheKey] = handler.apply(this, args)
    return cache[cacheKey]
  } as T;
}